import axios from "axios/index";
import * as types from "../store/mutation-types";
import store from '~/store'

export default {
    async getOrgs (cb) {
        const params = {}

        const {data} = await axios.get('/api/organisations', params)

        cb(data.data)
    },

    async getOrgDetail (orgId, cb) {
        const params = {}

        const {data} = await axios.get('/api/organisations/'+orgId, params)

        cb(data.data, data.users)
    },

    async deleteOrg (orgId, cb) {
        const params = {}

        await axios.delete('/api/organisations/'+orgId, params)

        cb()

    },

    async updateOrg (orgId, form) {
        const {data} = await form.patch('/api/organisations/'+orgId)

        if (form.successful) {
            store.dispatch('organisation/updateOrg', data)
        }
        return form.successful;
    },

    async createOrg (form) {
        await form.post('/api/organisations')

        return form.successful
    },

    async revokeAccess(orgAccessId, cb) {
        const params = {}

        const {data} = await axios.delete('/api/orgaccess/'+orgAccessId, params)

        cb(data.data, data.users)
    },

    async updateAccess(orgAccessId, level, cb) {
        const params = {
            level: level
        }

        const {data} = await axios.patch('/api/orgaccess/'+orgAccessId, params)

        cb(data.data, data.users)
    },

    async grantAccess(orgId, userId, level, cb) {
        const params = {
            organisation_id: orgId,
            user_id: userId,
            level: level
        }

        const {data} = await axios.post('/api/orgaccess', params)

        cb(data.data, data.users)
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/organisations.js